import mainLogo from '../../images/BelcarVW/belcarvw_logo_main_color.png';
import squareLogo from '../../images/BelcarVW/belcarvw_square_color.png';
import squareLogoWhite from '../../images/BelcarVW/belcarvw_square_white.png';
import mainLogoWhite from '../../images/BelcarVW/belcarvw_logo_main_white.png';
import banner01 from '../../images/BelcarVW/belcarvw_banner_02.jpg';
import banner02 from '../../images/BelcarVW/belcarvw_banner_01.jpg';
import banner03 from '../../images/BelcarVW/belcarvw_banner_03.jpg';
import car123 from '../../images/BelcarVW/123_tcross.jpg';
import box123 from '../../images/BelcarVW/123_belcarvw.jpg';
import { SliderProducts } from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'Belcar VW',
    defaultStoreLink: 'belcarpecas.com.br',
    defaultContactEmail: 'supervisorvendasvw@belcar.com.br',
    whatsappNumber: '62 99871 8302',
    CNPJ: '02.918.639/0001-86',
    CNPJname: 'BELCAR VEICULOS LTDA',
    CNPJaddress: 'Rua Recife Nº305, Alto da Glória, Goiânia/GO - CEP: 74.815-785',
    launchDate: '01/06/2025',

    multiContact: {},

    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAISTESTING',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        "volkswagen",
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        "BELCAR VW",
    ],

    disabledSellers: [],

    useMktNames: false,

    endYear: 2025,
    startYear: 1996,

    pixDiscount: 0.05,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            600: 4,
            800: 5,
            1000: 6,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.Kits
        },
        {
            name: 'Óleos',
            img: 'tabOleos',
            products: SliderProducts.Oleos
        },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.Filtros
        },
        {
            name: 'Freios',
            img: 'tabFreios',
            products: SliderProducts.Freios
        },
        {
            name: 'Acessórios',
            img: 'tabAcessorios',
            products: SliderProducts.Acessorios
        },
        // {
        //     name: 'Luzes',
        //     img: 'tabLuzes',
        //     products: SliderProducts.Luzes
        // },
        // {
        //     name: 'Roupas',
        //     img: 'tabRoupas',
        //     products: SliderProducts.Roupas
        // },
    ]
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogo,
    bannerLogoWhite: mainLogoWhite,

    banner01: banner01,
    banner02: banner02,
    bannerBrands: '',
    aboutUsBg: banner03,


    car123: car123,
    box123: box123,
    
    paymentImg: mainLogo,
    paymentImgMobile: mainLogo,

    bannerHighlight: 'Compre peças <mark>novas e originais</mark>, compatíveis com seu Volkswagen. Peças <mark>genuínas</mark> direto das concessionárias <mark>Belcar VW</mark>.',

    aboutUs: {
        title: 'Sobre nós',
        content: [
            'Missão: Nossa missão é oferecer aos nossos clientes exclusivamente peças genuínas e serviços de alta qualidade, sempre com transparência e compromisso. Trabalhamos continuamente em inovação e aprimoramento dos nossos processos, garantindo soluções eficazes que atendem e superam as expectativas de nossos clientes. Buscamos proporcionar uma experiência de compra confiável e satisfatória, criando um vínculo sólido e duradouro com cada cliente.',
            'Visão: Ser reconhecido como a principal referência regional na comercialização de peças automotivas genuínas, destacando-se pela excelência, confiança e qualidade no atendimento. Nosso objetivo é ser a primeira escolha dos nossos clientes, colaboradores e parceiros, construindo um legado de credibilidade e respeito no mercado, com foco na melhoria contínua e na criação de relações sustentáveis e de longo prazo.',
            'Valores: Priorizamos a autenticidade, oferecendo apenas peças genuínas e confiáveis. A segurança de nossos clientes é sempre a nossa prioridade, e trabalhamos com respeito e compromisso para garantir o melhor atendimento. Buscamos constantemente a excelência em todos os nossos processos, entregando serviços de qualidade. Agimos com integridade, mantendo ética, transparência e honestidade em todas as nossas ações. E temos um forte compromisso com a sustentabilidade, adotando práticas que respeitam o meio ambiente e a sociedade.',
            'Política de Qualidade: O Grupo Belcar está comprometido com a entrega de produtos genuínos e serviços de qualidade superior, investindo constantemente em tecnologia, inovação e capacitação de nossos colaboradores. Nossa política de qualidade foca na melhoria contínua de todos os nossos processos, garantindo que cada cliente receba o melhor atendimento e as melhores peças disponíveis no mercado. A satisfação total do cliente é o nosso objetivo, e para alcançá-la, seguimos rigorosamente os mais altos padrões de qualidade e ética.',
        ],
        link: 'https://www.belcar.com.br/veiculos/institucional',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Google: '',
        Instagram: 'https://www.instagram.com/belcarvolkswagen/',
        Facebook: 'https://www.facebook.com/BelcarVolkswagen/?locale=pt_BR',
        LinkedIn: 'https://br.linkedin.com/company/belcar-veiculos',
        Youtube: 'https://www.youtube.com/channel/UCerFk1_D6S4OpoYKn1ArhCA',
        Twitter: '',
    },

    footerContent: [],
}